import { useState } from 'react';

const services = [
  {
    icon: 'ri-truck-line',
    title: 'Dry Van Transport',
    description: 'Secure enclosed trailer transportation for temperature-sensitive and protected freight across all routes.'
  },
  {
    icon: 'ri-stack-line',
    title: 'Flatbed Hauling',
    description: 'Specialized flatbed services for oversized loads, construction materials, and heavy equipment transport.'
  },
  {
    icon: 'ri-arrow-left-right-line',
    title: 'Cross Dock Services',
    description: 'Efficient transfer of shipments from inbound to outbound trucks with minimal storage time.'
  },
  {
    icon: 'ri-building-line',
    title: 'Warehousing Solutions',
    description: 'Secure storage facilities with inventory management and distribution capabilities in Dallas, TX.'
  },
  {
    icon: 'ri-box-3-line',
    title: 'Load Restacking',
    description: 'Professional cargo reorganization and consolidation services to optimize space and protect goods.'
  },
  {
    icon: 'ri-home-line',
    title: 'Final Mile Delivery',
    description: 'Last-leg delivery services ensuring your freight reaches its final destination safely and on time.'
  },
  {
    icon: 'ri-parking-box-line',
    title: 'Drop Trailer Service',
    description: 'Flexible drop-and-hook solutions for efficient loading and unloading at your convenience.'
  },
  {
    icon: 'ri-archive-line',
    title: 'Storage Solutions',
    description: 'Short and long-term trailer storage options with 24/7 security monitoring and easy access.'
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Regional & OTR',
    description: 'Comprehensive coverage with regional expertise and over-the-road services nationwide.'
  }
];

export default function Services() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section id="services" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block bg-green-100 text-green-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            OUR SERVICES
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Logistics Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From pickup to delivery, we handle every aspect of your freight needs with precision and care.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className={`p-8 rounded-2xl transition-all duration-300 cursor-pointer ${
                hoveredIndex === index
                  ? 'bg-slate-800 shadow-2xl transform -translate-y-1'
                  : 'bg-white shadow-md hover:shadow-lg'
              }`}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div
                className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 transition-colors ${
                  hoveredIndex === index
                    ? 'bg-green-600'
                    : 'bg-green-100'
                }`}
              >
                <i
                  className={`${service.icon} text-2xl ${
                    hoveredIndex === index ? 'text-white' : 'text-green-600'
                  }`}
                ></i>
              </div>
              <h3
                className={`text-xl font-bold mb-3 transition-colors ${
                  hoveredIndex === index ? 'text-white' : 'text-gray-900'
                }`}
              >
                {service.title}
              </h3>
              <p
                className={`text-sm leading-relaxed transition-colors ${
                  hoveredIndex === index ? 'text-gray-300' : 'text-gray-600'
                }`}
              >
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}